export var BubbleState;
(function (BubbleState) {
    BubbleState["DEFAULT"] = "DEFAULT";
    BubbleState["PENDING"] = "PENDING";
    BubbleState["ERROR"] = "ERROR";
    BubbleState["LOADING_TYPING"] = "LOADING_TYPING";
})(BubbleState || (BubbleState = {}));
//# sourceMappingURL=state.js.map